<template>
  <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.0697 2.75684C7.0644 2.75684 2.17871 7.64253 2.17871 13.6478C2.17871 19.6531 7.0644 24.5388 13.0697 24.5388C19.075 24.5388 23.9607 19.6531 23.9607 13.6478C23.9607 7.64253 19.075 2.75684 13.0697 2.75684ZM10.8926 18.454L6.84876 14.4189L8.38657 12.8767L10.8904 15.3762L16.6561 9.61053L18.1961 11.1505L10.8926 18.454Z" fill="#1B1E21"/>
  </svg>
</template>